import React, { useEffect, useState } from "react";
import { getPage } from 'services/api/Shop';
import { getOfflineContent, saveOfflineContent } from '../../utils/offlineContent';

const Cgv = () => {
  const [data, setData] = useState("");
  const [isOfflineFallback, setIsOfflineFallback] = useState(false);

  useEffect(() => {
    const loadCgv = async () => {
      try {
        const response = await getPage(136);
        const nextContent = response?.content?.content || "";

        if (!nextContent) {
          throw new Error('CGV content unavailable');
        }

        setData(nextContent);
        setIsOfflineFallback(false);
        saveOfflineContent('cgv-page', nextContent);
      } catch (_error) {
        const cachedContent = getOfflineContent('cgv-page');

        if (cachedContent?.value) {
          setData(cachedContent.value);
          setIsOfflineFallback(true);
        }
      }
    };

    loadCgv();
  }, []);

  return (
    <div className="container">
      {isOfflineFallback && (
        <p className="offline-content-notice">
          Vous consultez la dernière version enregistrée de cette page.
        </p>
      )}
      <div dangerouslySetInnerHTML={{__html: data}} />
    </div>
  )
}

export default Cgv;
